import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { DatePipe } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { DeviceStoreSelectors } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { environment } from '@rocksoft/environment';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { AppleDevicePowerContainerComponent } from '../apple-device-power/apple-device-power.container';

@Component({
  selector: 'ml-mdm-apple-device',
  templateUrl: './apple-device.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    FaIconComponent,
    RouterLink,
    RouterLinkActive,
    AppleDevicePowerContainerComponent,
    RouterOutlet,
    DatePipe,
  ],
})
export class AppleDeviceComponent {
  private readonly store = inject(Store);

  public readonly selectedDevice = this.store.selectSignal(DeviceStoreSelectors.selectCurrentDevice);
  public readonly features: EnvironmentFeatures = environment.features;
}
